// Principaux transporteurs européens proposés dans les listes déroulantes
// (page Expéditions + transporteur par défaut de l'établissement).
export const CARRIERS = [
  "Colissimo",
  "Chronopost",
  "DHL",
  "UPS",
  "FedEx",
  "DPD",
  "GLS",
  "TNT",
  "Mondial Relay",
  "La Poste",
  "DB Schenker",
  "PostNL",
];

// Valeur sentinelle pour l'option "Autre" (saisie libre).
export const CARRIER_OTHER = "__other__";
